var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-not-found"},[_c('h1',[_vm._v("Not Found")]),_vm._v(" "),_c('p',[_vm._v("The requested URL "+_vm._s(_vm.$route.path)+" was not found on this server.")]),_vm._v(" "),_c('p',[_vm._v("\n    Additionally, a 404 Not Found error was encountered while trying\n    to use an ErrorDocument to handle the request.\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-540ea804","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThePageNotFound.vue
// module id = null
// module chunks = 